import keyMirror from "keymirror";

export default keyMirror({
  CREATE_PAYMENT: null,
  INIT_PAYMENTS: null,
  INIT_PAYMENT_METHODS: null,
});
